import { Component, Input, OnInit, inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { EnvironmentConfig } from '../../../client-config/index';
import { PubSubService } from '../../../core/services/communication/pubsub/pubsub.service';
import { VisIframeDimensionsDirective } from '../../directives/vis-iframe-dimensions.directive';

@Component({
    selector: 'vis-pre-match-widget',
    templateUrl: './vis-pre-match-widget.component.html',
    imports: [VisIframeDimensionsDirective],
})
export class VisPreMatchWidgetComponent implements OnInit {
    @Input() eventId: string;

    dimensionMultiplier: number = 0;
    visType: string = 'slider';
    iframeURL: SafeUrl;
    private readonly environment = inject(EnvironmentConfig).configuration;
    private VISUALIZATION_PREMATCH_URL: string = this.environment.VISUALIZATION_PREMATCH_URL || '';

    constructor(
        private domSanitizer: DomSanitizer,
        private pubSubService: PubSubService,
    ) {}

    ngOnInit(): void {
        this.iframeURL = this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.VISUALIZATION_PREMATCH_URL}#${this.eventId}`);
    }

    loadHandler(): void {
        this.pubSubService.publish(this.pubSubService.API.SCOREBOARD_VISUALIZATION_LOADED);
    }
}
